import { Grid, Typography } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import SmartAppPreview from "./components/SmartAppPreview";
import { observer } from "mobx-react-lite";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import { ActivityTypes } from "e.sic-platform.webclient/src/services/shop/ActivityPricesStorage";
import { SmartManagerBlack } from "e.sic-platform.webclient/src/components/svg/svgImageList";
import Svg from "e.sic-platform.webclient/src/components/svg/Svg";
import { Flags } from "e.sic-platform.webclient/src/generated/FeatureFlags";

export default observer(function HomePage() {
  const platformUrl = useMemo(() => {
    const configString = sessionStorage["config-storage"];
    var configStorage = JSON.parse(configString);
    return configStorage.platform_url;
  }, [])

  return (
    <>
      <Grid container spacing={2} sx={{ padding: 4 }} className="centered">
        <Grid item xs={12} sm={8} className="centered">
          <Typography variant="h4" sx={{ marginBottom: 2 }}>
            {translationService.translate("general.smartApps.title")}
          </Typography>
        </Grid>
        <Grid item xs={12} lg={8} className="centered">
          <Typography
            align="center"
            variant="body1"
            color="GrayText"
            sx={{ marginBottom: 3 }}
          >
            {translationService.translate("general.smartApps.description")}
          </Typography>
        </Grid>
      </Grid>

      <Grid container rowSpacing={{xs: 2, xl:10}} spacing={2} sx={{ padding: 4 }} className="centered">
        <SmartAppPreview
          title={"general.apps.analysis-and-segmentation.title"}
          image="images/analysis-and-segmentation.png"
          description={"general.apps.analysis-and-segmentation.description"}
          route={"/analysis-and-segmentation"}
          name={[ActivityTypes.VideoAnalysis, ActivityTypes.HighlightDetection]}
        />
        <SmartAppPreview
          title={"general.apps.video-analysis.title"}
          image="images/video-analysis.png"
          description={"general.apps.video-analysis.description"}
          route={"/video-analysis"}
          name={[ActivityTypes.VideoAnalysis]}
        />
        <SmartAppPreview
          title={"general.apps.video-segmentation.title"}
          image="images/video-segmentation.png"
          description={"general.apps.video-segmentation.description"}
          route={"/video-segmentation"}
          name={[ActivityTypes.HighlightDetection]}
        />
        <SmartAppPreview
          title={"general.apps.ocr-service.title"}
          image="images/ocr-service.png"
          description={"general.apps.ocr-service.description"}
          route={"/inspection-insights"}
          name={[ActivityTypes.VideoOcr]}
          enabled={Flags.Enable_Ocr}
        />
        <SmartAppPreview
          title={"general.apps.video-conversion.title"}
          image="images/video-conversion.png"
          description={"general.apps.video-conversion.description"}
          route={"/video-conversion"}
          name={[ActivityTypes.VideoConversion]}
        />
        <SmartAppPreview
          title={"general.apps.platform.title"}
          image={<Svg svg={SmartManagerBlack} />}
          description={"general.apps.platform.description"}
          route={platformUrl}
          hasPadding={true}
        />
      </Grid>
    </>
  );
});
